import { Link } from 'react-router-dom';
import { Shield, TrendingUp, ArrowRight, Phone } from 'lucide-react';
import SEO from '../components/shared/SEO';

const StarterPackExistingAuthorityPage = () => {
  return (
    <div data-testid="starter-pack-existing-authority-page" className="min-h-screen bg-[#0A0A0A]">
      <SEO 
        title="Already Have MC Authority - Queen B Logistics"
        description="You already have an active MC authority. Explore our Protect and Grow services instead."
      />
      
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h1 className="font-['Barlow_Condensed'] text-4xl md:text-5xl font-bold text-white uppercase mb-4">
            You're Already Established
          </h1>
          
          <p className="text-xl text-[#D4AF37] mb-6">
            The Signature Program is for new carriers building from scratch.
          </p>
          
          <p className="text-zinc-400 max-w-xl mx-auto">
            Since you already have an active MC authority, let's explore how we can help 
            you <strong className="text-white">protect</strong> and <strong className="text-white">grow</strong> your existing business.
          </p>
        </div>
        
        {/* Service Options */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">
          {/* Protect */}
          <div className="bg-zinc-900 border border-zinc-800 p-8 hover:border-emerald-500/30 transition-colors">
            <div className="w-14 h-14 bg-emerald-500/10 flex items-center justify-center mb-4">
              <Shield className="w-7 h-7 text-emerald-400" />
            </div>
            <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-white uppercase mb-2">
              Protect
            </h3>
            <p className="text-zinc-400 mb-6">
              Keep your authority active with compliance monitoring. We track deadlines, 
              renewals, and regulatory changes so you don't have to.
            </p>
            <ul className="space-y-2 mb-6 text-sm">
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-emerald-400" />
                Insurance expiration tracking
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-emerald-400" />
                UCR/IRP/IFTA deadline alerts
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-emerald-400" />
                Drug & Alcohol consortium management
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-emerald-400" />
                Regulatory update notifications
              </li>
            </ul>
            <Link 
              to="/compliance"
              className="flex items-center justify-center gap-2 w-full py-3 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 hover:bg-emerald-500/20 transition-colors"
            >
              Learn About Protect
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
          
          {/* Grow */}
          <div className="bg-zinc-900 border border-zinc-800 p-8 hover:border-[#D4AF37]/30 transition-colors">
            <div className="w-14 h-14 bg-[#D4AF37]/10 flex items-center justify-center mb-4">
              <TrendingUp className="w-7 h-7 text-[#D4AF37]" />
            </div>
            <h3 className="font-['Barlow_Condensed'] text-2xl font-bold text-white uppercase mb-2">
              Grow
            </h3>
            <p className="text-zinc-400 mb-6">
              Scale your revenue with dedicated dispatch support. We handle load booking, 
              broker negotiations, and back-office operations.
            </p>
            <ul className="space-y-2 mb-6 text-sm">
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-[#D4AF37]" />
                Dedicated dispatcher
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-[#D4AF37]" />
                Load booking & rate negotiation
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-[#D4AF37]" />
                24/7 driver support
              </li>
              <li className="flex items-center gap-2 text-zinc-300">
                <div className="w-1.5 h-1.5 bg-[#D4AF37]" />
                Invoice & factoring coordination
              </li>
            </ul>
            <Link 
              to="/pricing"
              className="flex items-center justify-center gap-2 w-full py-3 bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors"
            >
              View Dispatch Plans
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
        
        {/* Consultation CTA */}
        <div className="bg-gradient-to-r from-[#D4AF37]/10 to-[#D4AF37]/5 border border-[#D4AF37]/30 p-8 text-center">
          <h3 className="text-white font-bold text-xl mb-2">Not Sure Which Service You Need?</h3>
          <p className="text-zinc-400 mb-6">
            Schedule a free consultation and we'll help you identify the best path forward.
          </p>
          <Link 
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black font-bold hover:bg-[#F5D47B] transition-colors"
          >
            <Phone className="w-5 h-5" />
            Schedule Free Consultation
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StarterPackExistingAuthorityPage;
